<template>
  <div class="road">
    <img src="../assets/text1.png" class="text text1">
    <a v-link="{ name: 'online' }" class="btn btn1" data-rlog="btn.road.online">
      <img src="../assets/btn_click.png">
    </a>
    <img src="../assets/text2.png" class="text text2">
    <a v-link="{ name: 'blessing' }" class="btn btn2">
      <img src="../assets/btn_click.png">
    </a>
  </div>
</template>

<script>
  module.exports = {
    data: function () {
      return {}
    },
    ready: function () {
      //alert(window.innerWidth)
    }
  }
</script>

<style scoped>
  .road {
    width: 100%;
    height: 100%;
    background: url("./../assets/p5.jpg") 0 0/100% 100% no-repeat;
  }

  .text {
    display: block;
    width: 3.85rem;
    height: 1.25rem;
  }

  .text1{
    margin: 35% auto 0;
  }

  .text2 {
    margin: 14% auto 0;
  }

  .btn {
    width: 41%;
    height: 5.3%;
    -webkit-tap-highlight-color: transparent;
  }

  .btn1{
    margin: 0.42rem auto 0;
  }

  .btn2 {
    margin: 0.42rem auto 0;
  }

  @media screen  and (max-height: 600px) {
    .text1{
      margin: 25% auto 0;
    }
  }

  @media screen and (width: 320px) and (max-height: 460px) {
    .text1{
      margin: 23% auto 0;
    }
  }

  @media screen and (width: 320px) and (height: 480px) {
    .text1{
      margin: 20% auto 0;
    }
  }

  @media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){
    .text1{
      margin: 30% auto 0;
    }
  }

  @media screen and  (min-height: 800px) {
    .text1{
      margin: 50% auto 0;
    }
  }

  @media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){
    .text1{
      margin: 30% auto 0;
    }
  }
  @media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){
    .text1{
      margin: 30% auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Road.vue?d152867c